<template>
  <span class="w-echarts-pie2">
    <div id="w-pie2"></div>
  </span>
</template>

<script>
  import * as echarts from 'echarts';
  export default {
    props: {
      data: {
        type: Object
      }
    },
    data() {
      return {
        img: "/static/images/svolt/shandian.png",
      };
    },
    mounted() {
      window.addEventListener('resize', () => {
        if (this.myChart) {
          this.myChart.resize();
        }
      })
    },
    methods: {
      reset() {
        this.$nextTick(() => {
          let ct = echarts.getInstanceByDom(document.getElementById('w-pie2'));
          if (ct == undefined) {
            ct = echarts.init(document.getElementById('w-pie2'));
          }
          this.myChart = ct;
          let tmp = this.init();
          if (tmp) {
            ct.setOption(tmp);
          } else {
            console.log('数据问题chargingStatistics');
          }
        });
      },
      init() {
        var rich = {
          black: {
            color: "#19191A",
            fontFamily: 'PingFang',
            fontSize: 12,
            fontWeight: 'bold'
          },
          din: {
            fontSize: 16,
            fontFamily: 'DINBold'
          }
        }
        const colorList = ['#FEC05C', '#19CE9F', '#19CAE4', '#033A7C', '#01A8FB'];
        this.data.pieData.forEach((e, i) => {
          e.label = {
            color: colorList[i]
          }
        });
        let op = {
          color: colorList,
          title: {
            x: 'center',
            y: 85
          },
          graphic: {
            elements: [{
              type: "image",
              z: 3,
              style: {
                image: this.img,
                width: 110,
                height: 110
              },
              left: 'center',
              top: 'middle'
            }]
          },
          series: [{
              type: "pie",
              emphasis: {
                scale: true
              },
              hoverOffset: 25,
              startAngle: 180, //起始角度
              clockwise: false, //是否顺时针
              radius: [45, 65],
              center: ["50%", "50%"],
              avoidLabelOverlap: false,
              label: {
                show: true,
                // color: "#000",
                formatter: function(params) {
                  return '{black|' + params.name + '}\n{din|' + params.value + '}';
                },
                rich: rich
              },
              labelLine: {
                show: true,
                length: 10,
                length2: 10
              },
              data: this.data.pieData,
              itemStyle: {
                borderWidth: 20, // 间距的宽度
                // borderColor: 'rgba(40,48,65,1)', //背景色
              },
              zlevel: 30
            },
            { //最内层
              type: 'pie',
              radius: ['0%', '25%'],
              center: ["50%", "45%"],
              emphasis: {
                scale: false
              },
              clockwise: false,

              itemStyle: {
                color: {
                  type: 'radial',
                  x: 0.5,
                  y: 0.493,
                  r: 0.5,
                  global: false // 缺省为 false
                },
                opacity: 0,
                shadowBlur: 10,
                shadowColor: 'transparent',
              },
              label: {
                show: false
              },
              data: [100]
            },
            { //外发光
              type: 'pie',
              radius: ['40%', '60%'],
              center: ["50%", "45%"],
              emphasis: {
                scale: false
              },
              clockwise: false,
              itemStyle: {
                borderWidth: 20,
                color: 'transparent',
              },
              label: {
                show: false
              },
              data: [100]
            }
          ]
        };
        return op;
      }
    }
  };
</script>

<style lang="scss">
  .w-echarts-pie2 {
    position: relative;
    top: 0px;
    width: 100%;
    height: 100%;
    display: inline-block;
    z-index: 99;

    #w-pie2 {
      width: 100%;
      height: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/w-echarts-pie2.vue